/**
 * Painted-artwork slots for the Royal Mahal theme's code-drawn layers.
 *
 * Every slot is null by default, which renders the code-drawn SVG layer.
 * To swap in commissioned or licensed painted art, set a slot to an imported
 * image or a full URL (e.g. Cloudinary). Use a transparent PNG/WebP with the
 * same composition and anchor point noted beside each slot; nothing else needs
 * to change. (The palace itself is src/images/royal-mahal/palace.webp.)
 */
export const ART_SLOTS = {
  bougainvillea: null, // cascade anchored to the top-right corner (mirrored for left)
  rosesLeft: null, // rose bouquet, anchored bottom-left
  rosesRight: null, // rose bouquet, anchored bottom-right
  doorFrame: null, // sandstone gateway, 760x1190 ratio, transparent door opening
  doorLeft: null, // left door leaf, 300x800 ratio
  doorRight: null, // right door leaf, 300x800 ratio
};
